
import { ColumnDef } from "@tanstack/react-table"
// import Charts from "src/components/ui/common/Chart/Charts";
import { Switch } from "src/components/ui/switch";
import Datehistory from "./Datehistory";






export type TransactionHistoryProps = {
    date: string,
    rate: number,

}


export const columnsTransaction: ColumnDef<TransactionHistoryProps>[] = [
    {
        accessorKey: "date",
        header: " Date / Time",
        cell: ({ row: { original } }) => {
            return <Datehistory {...original} />
        }
    },
    {
        accessorKey: "ratePerUnit",
        header: "Rate ( ₹ ) ",
        // cell: (({ row }) => {
        //     let typ: string = row.getValue('type');
        //     return <SwitchComp types={typ} />
        // })
    },

    // {
    //     // accessorKey: "tradeAmount",
    //     id: 'trade',
    //     // header: "Trade Amount",
    //     cell: () => {
    //         return <Charts />
    //     }

    // },
]

